import { ARCADE_TYPES } from './cash-color'

export const TYPES = {
  BLACK: 'Black',
  BONDI_MINT: 'Bondi Mint',
  FIRE: 'Fire',
  GRAY10: 'Gray10',
  GRAY20: 'Gray20',
  GRAY30: 'Gray30',
  GRAY40: 'Gray40',
  GRAY50: 'Gray50',
  GRAY60: 'Gray60',
  GRAY70: 'Gray70',
  GRAY80: 'Gray80',
  GRAY90: 'Gray90',
  GRAY96: 'Gray96',
  LEMON_DARK: 'Lemon Dark',
  LEMON_PASTEL: 'Lemon Pastel',
  MOSS_GEM: 'Moss Gem',
  MOSS_MID: 'Moss Mid',
  MOSS_PASTEL: 'Moss Pastel',
  ORCA: 'Orca',
  ORCA_DARK: 'Orca Dark',
  ORCA_PASTEL: 'Orca Pastel',
  PRESS: 'Press',
  WHITE: 'White',
} as const

export const SEMANTIC_COLORS_TYPES = {
  PRIMARY: 'Primary',
  PRIMARY_HOVER: 'Primary Hover',
  PRIMARY_PRESS: 'Primary Press',
  PRIMARY_FOCUS: 'Primary Focus',
  PRIMARY_DISABLED: 'Primary Disabled',
  PROMINENT: 'Prominent',
  PROMINENT_PRESS: 'Prominent Press',
  PROMINENT_DISABLED: 'Prominent Disabled',
  INVERSE: 'Inverse',
  INVERSE_PRESS: 'Inverse Press',
  INVERSE_DISABLED: 'Inverse Disabled',
  INFO: 'Info',
  INFO_DARK: 'Info Dark',
  INFO_LIGHT: 'Info Light',
  INFO_PRESS: 'Info Press',
  INFO_DISABLED: 'Info Disabled',
  ACCENT_DARK: 'Accent Dark',
  ACCENT_LIGHT: 'Accent Light',
  SUCCESS: 'Success',
  SUCCESS_LIGHT: 'Success Light',
  SUCCESS_DARK: 'Success Dark',
  ERROR: 'Error',
  WARNING: 'Warning',
  NEUTRAL_BLACK: 'Neutral Black',
  NEUTRAL_WHITE: 'Neutral White',
  NEUTRAL_100: 'Neutral 100',
  NEUTRAL_150: 'Neutral 150',
  NEUTRAL_300: 'Neutral 300',
  NEUTRAL_400: 'Neutral 400',
  NEUTRAL_450: 'Neutral 450',
  NEUTRAL_500: 'Neutral 500',
  NEUTRAL_600: 'Neutral 600',
  NEUTRAL_650: 'Neutral 650',
  NEUTRAL_900: 'Neutral 900',
} as const

export const LEGACY_TO_SEMANTIC_MAPPING: Record<string, string> = {
  [TYPES.BLACK]: SEMANTIC_COLORS_TYPES.PROMINENT,
  [TYPES.WHITE]: SEMANTIC_COLORS_TYPES.INVERSE,
  [TYPES.FIRE]: SEMANTIC_COLORS_TYPES.ERROR,
  [TYPES.GRAY10]: SEMANTIC_COLORS_TYPES.NEUTRAL_BLACK,
  [TYPES.GRAY20]: SEMANTIC_COLORS_TYPES.NEUTRAL_900,
  [TYPES.GRAY30]: SEMANTIC_COLORS_TYPES.NEUTRAL_650,
  [TYPES.GRAY40]: SEMANTIC_COLORS_TYPES.NEUTRAL_600,
  [TYPES.GRAY50]: SEMANTIC_COLORS_TYPES.NEUTRAL_500,
  [TYPES.GRAY60]: SEMANTIC_COLORS_TYPES.NEUTRAL_450,
  [TYPES.GRAY70]: SEMANTIC_COLORS_TYPES.NEUTRAL_400,
  [TYPES.GRAY80]: SEMANTIC_COLORS_TYPES.NEUTRAL_300,
  [TYPES.GRAY90]: SEMANTIC_COLORS_TYPES.NEUTRAL_150,
  [TYPES.GRAY96]: SEMANTIC_COLORS_TYPES.NEUTRAL_100,
  [TYPES.BONDI_MINT]: SEMANTIC_COLORS_TYPES.PRIMARY,
  [TYPES.ORCA]: SEMANTIC_COLORS_TYPES.INFO,
  [TYPES.ORCA_DARK]: SEMANTIC_COLORS_TYPES.INFO_DARK,
  [TYPES.ORCA_PASTEL]: SEMANTIC_COLORS_TYPES.INFO_LIGHT,
  [TYPES.MOSS_GEM]: SEMANTIC_COLORS_TYPES.SUCCESS_DARK,
  [TYPES.MOSS_MID]: SEMANTIC_COLORS_TYPES.SUCCESS,
  [TYPES.MOSS_PASTEL]: SEMANTIC_COLORS_TYPES.SUCCESS_LIGHT,
  [TYPES.LEMON_DARK]: SEMANTIC_COLORS_TYPES.ACCENT_DARK,
  [TYPES.LEMON_PASTEL]: SEMANTIC_COLORS_TYPES.ACCENT_LIGHT,
  [TYPES.PRESS]: SEMANTIC_COLORS_TYPES.PRIMARY_PRESS,

  [ARCADE_TYPES.BRAND]: SEMANTIC_COLORS_TYPES.PRIMARY,
  [ARCADE_TYPES.BRAND_DARK]: SEMANTIC_COLORS_TYPES.PRIMARY,
  [ARCADE_TYPES.PROMINENT_DARK]: SEMANTIC_COLORS_TYPES.PROMINENT,
  [ARCADE_TYPES.STANDARD]: SEMANTIC_COLORS_TYPES.NEUTRAL_900,
  [ARCADE_TYPES.STANDARD_DARK]: SEMANTIC_COLORS_TYPES.NEUTRAL_150,
  [ARCADE_TYPES.SUBTLE]: SEMANTIC_COLORS_TYPES.NEUTRAL_500,
  [ARCADE_TYPES.SUBTLE_DARK]: SEMANTIC_COLORS_TYPES.NEUTRAL_400,
  [ARCADE_TYPES.EXTRASUBTLE]: SEMANTIC_COLORS_TYPES.NEUTRAL_450,
  [ARCADE_TYPES.EXTRASUBTLE_DARK]: SEMANTIC_COLORS_TYPES.NEUTRAL_600,
  [ARCADE_TYPES.INVERSE_DARK]: SEMANTIC_COLORS_TYPES.NEUTRAL_900,
  [ARCADE_TYPES.DISABLED]: SEMANTIC_COLORS_TYPES.NEUTRAL_450,
  [ARCADE_TYPES.DISABLED_DARK]: SEMANTIC_COLORS_TYPES.NEUTRAL_600,
  [ARCADE_TYPES.DANGER]: SEMANTIC_COLORS_TYPES.ERROR,
  [ARCADE_TYPES.DANGER_DARK]: SEMANTIC_COLORS_TYPES.ERROR,
  [ARCADE_TYPES.WARNING_DARK]: SEMANTIC_COLORS_TYPES.WARNING,
}

export const COLOR_PALETTE_MAP = {
  semantic: {
    ...Object.fromEntries(Object.values(SEMANTIC_COLORS_TYPES).map((value) => [value, value])),
  },
  legacy: {
    ...Object.fromEntries(Object.values(TYPES).map((value) => [value, value])),
    ...Object.fromEntries(Object.values(ARCADE_TYPES).map((value) => [value, value])),
  },
} as const

type BronteColorTypesType = typeof TYPES
type ArcadeColorTypesType = typeof ARCADE_TYPES
type SemanticColorTypesType = typeof SEMANTIC_COLORS_TYPES
export type ColorTypesType = BronteColorTypesType & ArcadeColorTypesType & SemanticColorTypesType

type BronteColorTypesKeys = keyof BronteColorTypesType
type ArcadeColorTypesKeys = keyof ArcadeColorTypesType
type SemanticColorTypesKeys = keyof SemanticColorTypesType
export type ColorTypesKeys = BronteColorTypesKeys | ArcadeColorTypesKeys | SemanticColorTypesKeys

export type ColorTypes = ColorTypesType[ColorTypesKeys]
